import { FC } from 'react';
import { useSelector } from 'react-redux';
import { teamBenchlingSyncActivatedSelector } from '@/support/Selectors';
import { RiCheckboxCircleFill, RiAlertFill } from 'react-icons/ri';
import styles from './SyncingActive.module.scss';

const SyncingActive: FC = () => {
  const isActive = useSelector(teamBenchlingSyncActivatedSelector);
  const containerClass = `${styles.container} ${isActive ? styles.active : styles.inactive}`;

  return (
    <div className={containerClass}>
      {isActive ? (
        <>
          <RiCheckboxCircleFill className={styles.icon} size={16} />
          <span className={styles.text}>Syncing active</span>
        </>
      ) : (
        <>
          <RiAlertFill className={styles.icon} size={16} />
          <span className={styles.text}>Syncing inactive</span>
        </>
      )}
    </div>
  );
};

export default SyncingActive;
